import { get } from 'lodash';
import { apiClientInstance } from '../../api/axiosClient';
import { metricsApi } from '../../api/metricsApi';
import apiMessageToProductMessage from '../../api/apiMessageToProductMessage';

export const getSweepByConsumerId = async ({ consumerId }) => {
    let response;

    try {
        const { data } = await apiClientInstance.get(
            `/client/sweepstake?consumerId=${consumerId}`
        );
        const closestEvent = data;

        response = {
            data: {
                sweepId: closestEvent.sweepId,
                name: closestEvent.name,
                description: closestEvent.description,
                prize: closestEvent.prize,
                status: closestEvent.status,
                openDate: closestEvent.openDate,
                closeDate: closestEvent.closeDate,
                event: {
                    name: closestEvent.event.name,
                    startDate: closestEvent.event.startDate,
                    winningSelections: closestEvent.event.winningSelections
                }
            },
            errorMessage: null
        };
    } catch (err) {
        let errorMessage;
        if (err.response) {
            errorMessage = get(err, 'response.data.message', 'Unknown error');
        } else {
            errorMessage = err.message;
        }

        response = {
            data: null,
            errorMessage: apiMessageToProductMessage(errorMessage)
        };
        const statusCode = get(err, 'response.status', 500);

        await metricsApi.errorMetric(
            'getSweepByConsumerId',
            statusCode,
            errorMessage
        );
    }
    return response;
};

export const getEntryBySweepId = async ({ sweepId, productToken }) => {
    let response;

    try {
        const { data } = await apiClientInstance.get(
            `/client/sweepstake/${sweepId}/entry`,
            {
                headers: {
                    Authorization: `Bearer ${productToken}`
                }
            }
        );

        response = {
            data: {
                selection: {
                    id: data.selection.id,
                    name: data.selection.name,
                    metaData: data.selection.metaData
                },
                hasEntered: true
            },
            errorMessage: null
        };
    } catch (err) {
        const statusCode = get(err, 'response.status', 500);

        if (statusCode === 404) {
            response = {
                data: {
                    selection: {
                        id: null,
                        name: null,
                        metaData: {}
                    },
                    hasEntered: false
                },
                errorMessage: null
            };
        } else {
            let errorMessage;
            if (err.response) {
                errorMessage = get(
                    err,
                    'response.data.message',
                    'Unknown error'
                );
            } else {
                errorMessage = err.message;
            }
            response = {
                data: {
                    selection: {
                        id: null,
                        name: null,
                        metaData: {}
                    },
                    hasEntered: false
                },
                errorMessage
            };

            await metricsApi.errorMetric(
                'getEntryBySweepId',
                statusCode,
                errorMessage
            );
        }
    }

    return response;
};
